module.exports = __webpack_public_path__ + "img/woman-mountains.7be87cd8.jpeg";